// PropTypes test
// Ensure that if any of the supplied proptypes are used, that all of them are used
// e.g.
// 1 1 - true
// 0 1 - false
// 1 0 - false
// 0 0 - true
export let dependentProps = propNames => props => {
  if (
    propNames.reduce((acc, curr) => (props[curr] !== undefined) ^ acc, false)
  ) {
    return new Error(
      `[${propNames.join(", ")}] are required to use this functionality.`
    );
  }
};
